<div id="sidebar" [ngClass]="{'showSidebar': showSidebar, 'sidebar__external': external, 'showNav': displayNav}">
    <aside class="sidebar-new w-full" *ngIf="course">
          <div  class=" bg-white my-2 overflow-hidden ml-1 shadow-container" style="border-radius: 18px !important;"
            [class.is-scroll-mode]="isSubmenuOverflowing()">

            <!-- Header -->
            <div class="sidebar__header p-4 border-b border-gray-100">
                <div class="flex items-start gap-3">
                    <!-- Course logo / icon -->
                    <!-- Course logo / icon 
                    <div class="hidden w-11 h-11 rounded-[8px] md:flex items-center justify-center flex-shrink-0 overflow-hidden bg-cover bg-center"
                        [style.background-color]="'var(--secondary-500)'"
                        [style.background-image]="logo ? 'url(' + logo + ')' : 'none'">
                        <svg viewBox="0 0 24 24" class="w-6 h-6" fill="none" stroke="white" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                            <path
                                d="M14.5 21v-3.2c2.4-.9 4-3 4-5.6V9.5c0-3.6-2.9-6.5-6.5-6.5h-.3C8.4 3 5.5 5.7 5.3 9.2L4.2 12c-.2.4.1.9.6.9H6v2.5c0 1.1.9 2 2 2h1.5V21">
                            </path>
                            <circle cx="19" cy="5" r="1" fill="white" stroke="none"></circle>
                            <circle cx="21.5" cy="3" r="0.7" fill="white" stroke="none"></circle>
                        </svg>
                    </div>-->

                    <!-- Title / Subtitle -->
                    <a class="sidebar__title flex-1 min-w-0 no-underline" [routerLink]="['/course', course?.id]"
                        [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact: true}"
                        queryParamsHandling="merge">
                        <h2 class="m-0 text-base font-bold text-[#22304C] leading-tight line-clamp-2 group-hover:text-[hsl(var(--primary))] transition-colors"
                            [title]="course?.title || ('player.untitled-course' | translate)">
                            {{ course?.title || ('player.untitled-course' | translate) }}
                        </h2>
                        <!-- <p  class="text-xs text-gray-600 mt-0.5 truncate m-0">
                            {{ (course.isTrajectContent ? 'course.course-presentation' : 'studio.presentation.template')
                            | translate }}
                        </p> -->
                    </a>

                    <!-- Collapse button (desktop) -->
                    <button
                        class="sidebar__collapse-desktop w-7 h-7 text-gray-400 inline-flex items-center justify-center cursor-pointer rounded-full border border-gray-400 bg-white"
                        [attr.aria-label]="'words.menu' | translate" (click)="collapseDesktop($event)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-3.5 h-3.5">
                            <path d="m15 18-6-6 6-6"></path>
                        </svg>
                    </button>

                    <!-- Close button (mobile): cierra el drawer -->
                    <button
                        class="sidebar__close-mobile w-7 h-7 text-[#22304C] inline-flex items-center justify-center cursor-pointer rounded-[6px] border border-[#E8EAEF] bg-white"
                        type="button" [attr.aria-label]="'words.close' | translate"
                        (click)="$event.stopPropagation(); closeMobileDrawer()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-3.5 h-3.5">
                            <path d="M18 6 6 18"></path>
                            <path d="m6 6 12 12"></path>
                        </svg>
                    </button>
                </div>

                <!-- Progress bar -->
                <div class="sidebar__progress mt-2 flex items-center justify-between text-[11px] font-normal tracking-wide">
                    <span [style.color]="getOverallProgress() === 1 ? 'text-gray-700' : '#22304C'">
                        {{ (getOverallProgress() * 100) | number:'1.0-0' }}% {{ (getOverallProgress() >= 1 ?
                        'words.completed' : 'group.team.in-progress') | translate | uppercase }}
                    </span>
                    <span class="text-gray-600">
                        {{ getCompletedLessons() }}/{{ getTotalLessons() }} {{ 'words.lessons' | translate }}
                    </span>
                </div>
                <div class="sidebar__progress mt-2 flex items-center">
                    <div class="flex-1 h-1.5 rounded-full bg-[#F6F7F9] overflow-hidden">
                        <div class="h-full rounded-full transition-all duration-500"
                            [class.bg-green-500]="getOverallProgress() >= 1"
                            [style.width.%]="getOverallProgress() * 100"
                            [style.background]="getOverallProgress() >= 1 ? null : 'linear-gradient(90deg, var(--v2-color-secondary-700), var(--v2-color-secondary-600), var(--v2-color-secondary-500))'">
                        </div>
                    </div>
                    <svg *ngIf="getOverallProgress() >= 1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" class="ml-2 flex-shrink-0 text-green-500">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="m9 12 2 2 4-4"></path>
                    </svg>
                </div>
            </div>

            <!-- Modules list -->
            <div class="module-list px-3 py-3 divide-y divide-[#E8EAEF]">
                <div *ngFor="let section of course.sections; let index=index"
                    class="py-2.5 first:pt-0 last:pb-0 relative" [ngClass]="{'section__disabled': isDisabled(section)}">

                    <!-- Disabled tooltip (sin icono: solo texto al hacer hover) -->
                    <div class="section__tooltip tooltip" [attr.data-tooltip]="'player.section.disabled' | translate"
                        *ngIf="isDisabled(section)">
                    </div>

                    <!-- Module header -->
                    <a class="sidebar__module-link relative flex items-center gap-3 px-2 cursor-pointer transition-colors no-underline"
                        [ngClass]="{
                            'rounded-[8px] section-active': sectionOpen[index] && !isDisabled(section),
                            'rounded-xl': !sectionOpen[index] || isDisabled(section),
                            'disabled': isDisabled(section)
                        }"
                        [attr.style]="sectionOpen[index] && !isDisabled(section) ? 'background: color-mix(in hsl, var(--secondary-100) 75%, var(--secondary-200) 25%) !important' : ''"
                        [routerLink]="['section', section?.id]" queryParamsHandling="merge"
                        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}"
                        (click)="openSection(section, 'template'); $event.stopPropagation(); $event.preventDefault();">

                        <!-- Barra indicadora izquierda (píldora redondeada) -->
                        <span class="absolute left-0 top-1/2 -translate-y-1/2 w-[2px] h-6 rounded-full transition-opacity duration-200"
                            style="background: var(--secondary-color);"
                            [style.opacity]="sectionOpen[index] && !isDisabled(section) ? '1' : '0'"></span>

                        <!-- Section progress circle: number + ring. Hover reveals % -->
                        <!-- <span
                            class="group/num relative w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-[8px]"
                           [attr.style]="!(sectionOpen[index] && !isDisabled(section)) ? 'background: #F6F7F9 !important' : ''"> -->
                        <span
                            class="sidebar__module-num group/num relative w-6 h-8 flex items-center justify-start flex-shrink-0 rounded-[8px]"
                            [attr.style]="!(sectionOpen[index] && !isDisabled(section)) ? 'background: transparent !important' : ''">
                            <!-- Inner white disc behind the number -->
                            <span class="sidebar__module-disc absolute rounded-full "
                                style="top: 50%; left: 50%; width: 22px; height: 22px; transform: translate(-50%, -50%);"></span>
                            <!-- Circular track + progress ring: only when NOT 100% -->
                            <svg class="absolute -rotate-90" viewBox="0 0 24 24" width="24" height="24"
                                [ngClass]="courseSubscriptionSession?.getSectionProgress(section) >= 1 ? 'hidden group-hover/num:block' : ''"
                                style="top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(-90deg);">
                                <!-- Track: always visible -->
                                <circle cx="12" cy="12" r="10" fill="none" stroke="#E5E7EB" stroke-width="2">
                                </circle>
                                <!-- Progress arc -->
                                <circle cx="12" cy="12" r="10" fill="none" [style.stroke]="'var(--secondary-color)'"
                                    style="opacity: 1;" stroke-width="2" stroke-linecap="round"
                                    [attr.stroke-dasharray]="(courseSubscriptionSession?.getSectionProgress(section) * 62.83) + ' 62.83'">
                                </circle>
                            </svg>

                            <!-- Default: checkmark if 100%, number otherwise -->
                            <span
                                class="absolute inset-0 leading-none group-hover/num:hidden flex items-center justify-center">
                                <!-- Completed: checkmark icon only, no ring -->
                                <ng-container
                                    *ngIf="courseSubscriptionSession?.getSectionProgress(section) >= 1; else showNumber">
                                    <span class="w-4 h-4 rounded-full flex items-center justify-center"
                                        style="background: var(--secondary-color);">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="w-2.5 h-2.5 text-white">
                                            <path d="M20 6 9 17l-5-5"></path>
                                        </svg>
                                    </span>
                                </ng-container>
                                <!-- Not completed: number -->
                                <ng-template #showNumber>
                                    <span class="text-[10px] font-normal"
                                        [style.color]="isDisabled(section) ? '#9CA3AF' : (courseSubscriptionSession?.getSectionProgress(section) > 0 ? 'var(--secondary-color)' : '#374151')">
                                        {{ index + 1 }}
                                    </span>
                                </ng-template>
                            </span>

                            <!-- Hover: progress percentage (non-disabled) -->
                            <span
                                class="absolute inset-0 items-center justify-center text-[8px] font-normal leading-none hidden group-hover/num:flex"
                                *ngIf="!isDisabled(section)" style="color: #374151;">
                                {{ courseSubscriptionSession?.getSectionProgress(section) * 100 | number:'1.0-0' }}%
                            </span>

                            <!-- Hover disabled: lock icon -->
                            <span class="absolute inset-0 items-center justify-center hidden group-hover/num:flex"
                                *ngIf="isDisabled(section)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <rect width="18" height="11" x="3" y="11" rx="2" ry="2"></rect>
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                                </svg>
                            </span>
                        </span>



                        <!-- Title -->
                        <span class="sidebar__module-title flex-1 text-sm font-normal line-clamp-2" [title]="section.title"
                            [style.color]="isDisabled(section) ? '#9CA3AF' : (sectionOpen[index] ? 'var(--secondary-color)' : '#374151')"
                            [innerHTML]="section.title || ('player.common.untitled' | translate)"></span>

                        <!-- Right icon: lock if disabled, chevron otherwise -->
                        <svg *ngIf="isDisabled(section)" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="sidebar__module-caret w-3.5 h-3.5 text-gray-400">
                            <rect width="18" height="11" x="3" y="11" rx="2" ry="2"></rect>
                            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                        </svg>

                        <svg *ngIf="!isDisabled(section)" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round"
                            class="sidebar__module-caret w-4 h-4 text-gray-600 transition-transform duration-200"
                            [class.rotate-180]="sectionOpen[index]">
                            <path d="m6 9 6 6 6-6"></path>
                        </svg>
                    </a>

                    <!-- Sub-contents -->
                    <!-- border-l-2: línea solo si hay ≥2 lecciones y NO es el último módulo (si no, quedaría sin número al cual conectar). -->
                    <div *ngIf="sectionOpen[index] && !isDisabled(section)"
                        class="sidebar__subcontents mt-1 ml-[19px] pl-[9px] space-y-0.5 border-[#E8EAEF]"
                        [class.border-l-2]="section?.sectionContents?.length > 1 && index < (course?.sections?.length - 1)">
                        <ng-container *ngFor="let sectionContent of section?.sectionContents; let scIndex=index">

                            <!-- Regular content -->
                            <a *ngIf="sectionContent?.context !== 'exercise'" queryParamsHandling="merge"
                                [routerLink]="navigate(sectionContent, section)" routerLinkActive
                                #rla="routerLinkActive" [routerLinkActiveOptions]="{exact:true}"
                                class="sub-link w-full flex items-center gap-3 px-2.5 py-2.5 rounded-xl text-left transition-colors no-underline cursor-pointer"
                                [ngClass]="getSectionContentClasses(sectionContent?.id)"
                                [attr.style]="rla.isActive ? 'background: color-mix(in hsl, var(--secondary-100) 75%, var(--secondary-200) 25%) !important' : ''"
                                (click)="scroller()">

                                <!-- Context-based icon (color reflects state: done -> secondary, active -> secondary, pending -> gray-500) -->
                                <span class="w-4 h-4 flex-shrink-0 flex items-center justify-center"
                                    [style.color]="rla.isActive || isContentDone(sectionContent?.id) ? 'var(--secondary-color)' : '#6B7280'">
                                    <ng-container *ngIf="isContentDone(sectionContent?.id)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 flex-shrink-0"
                                            style="color: currentColor;">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <path d="m9 12 2 2 4-4"></path>
                                        </svg>
                                    </ng-container>
                                    <ng-container *ngIf="!isContentDone(sectionContent?.id)"
                                        [ngSwitch]="getContentIconKey(sectionContent)">

                                        <!-- VIDEO -->
                                        <svg *ngSwitchCase="'video'" xmlns="http://www.w3.org/2000/svg" width="24"
                                            height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="w-4 h-4">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <polygon points="10 8 16 12 10 16 10 8"></polygon>
                                        </svg>

                                        <!-- AUDIO -->
                                        <svg *ngSwitchCase="'audio'" xmlns="http://www.w3.org/2000/svg" width="24"
                                            height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="w-4 h-4">
                                            <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
                                            <path
                                                d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z">
                                            </path>
                                        </svg>

                                        <!-- PDF / DOCUMENT / CHEATSHEET / GENERIC MEDIA -->
                                        <svg *ngSwitchCase="'pdf'" xmlns="http://www.w3.org/2000/svg" width="24"
                                            height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="w-4 h-4">
                                            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                                            <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                                            <path d="M10 9H8"></path>
                                            <path d="M16 13H8"></path>
                                            <path d="M16 17H8"></path>
                                        </svg>
                                        <svg *ngSwitchCase="'document'" xmlns="http://www.w3.org/2000/svg" width="24"
                                            height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="w-4 h-4">
                                            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                                            <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                                            <path d="M16 13H8"></path>
                                            <path d="M16 17H8"></path>
                                            <path d="M10 9H8"></path>
                                        </svg>
                                        <i *ngSwitchCase="'media'" class="icon-sub icon icon-media"
                                            style="color: currentColor !important;"></i>

                                        <!-- IMAGE -->
                                        <svg *ngSwitchCase="'image'" xmlns="http://www.w3.org/2000/svg" width="24"
                                            height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="w-4 h-4">
                                            <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
                                            <circle cx="9" cy="9" r="2"></circle>
                                            <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
                                        </svg>

                                        <!-- DISCUSSION -->
                                        <svg *ngSwitchCase="'discussion'" xmlns="http://www.w3.org/2000/svg" width="24"
                                            height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="w-4 h-4">
                                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z">
                                            </path>
                                        </svg>

                                        <!-- EXCHANGE -->
                                        <svg *ngSwitchCase="'exchange'" xmlns="http://www.w3.org/2000/svg" width="24"
                                            height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="w-4 h-4">
                                            <path d="M17 1l4 4-4 4"></path>
                                            <path d="M3 11V9a4 4 0 0 1 4-4h14"></path>
                                            <path d="M7 23l-4-4 4-4"></path>
                                            <path d="M21 13v2a4 4 0 0 1-4 4H3"></path>
                                        </svg>

                                        <!-- EVENT (calendar) -->
                                        <svg *ngSwitchCase="'event'" xmlns="http://www.w3.org/2000/svg" width="24"
                                            height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="w-4 h-4">
                                            <rect width="18" height="18" x="3" y="4" rx="2" ry="2"></rect>
                                            <line x1="16" x2="16" y1="2" y2="6"></line>
                                            <line x1="8" x2="8" y1="2" y2="6"></line>
                                            <line x1="3" x2="21" y1="10" y2="10"></line>
                                        </svg>

                                        <!-- PROJECT / SELF-ASSESSMENT -->
                                        <svg *ngSwitchCase="'project'" xmlns="http://www.w3.org/2000/svg" width="24"
                                            height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="w-4 h-4">
                                            <rect width="8" height="4" x="8" y="2" rx="1" ry="1"></rect>
                                            <path
                                                d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2">
                                            </path>
                                            <path d="m9 14 2 2 4-4"></path>
                                        </svg>

                                        <!-- SCORM -->
                                        <svg *ngSwitchCase="'scorm'" xmlns="http://www.w3.org/2000/svg" width="24"
                                            height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="w-4 h-4">
                                            <path
                                                d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
                                            </path>
                                            <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                                            <line x1="12" x2="12" y1="22.08" y2="12"></line>
                                        </svg>

                                        <!-- EXTERNAL LINK -->
                                        <i *ngSwitchCase="'link'" class="icon-sub icon icon-link-outline"
                                            style="color: currentColor !important;"></i>

                                        <!-- CERTIFICATE -->
                                        <svg *ngSwitchCase="'certificate'" xmlns="http://www.w3.org/2000/svg" width="24"
                                            height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="w-4 h-4">
                                            <circle cx="12" cy="8" r="6"></circle>
                                            <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"></path>
                                        </svg>

                                        <!-- DEFAULT -->
                                        <svg *ngSwitchDefault xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                                            <circle cx="12" cy="12" r="10"></circle>
                                        </svg>
                                    </ng-container>
                                </span>

                                <span class="flex-1 text-sm line-clamp-2 min-w-0" [title]="sectionContent.title"
                                    [style.fontWeight]="rla.isActive ? '500' : '400'"
                                    [style.color]="rla.isActive ? 'var(--secondary-color)' : '#374151'">
                                    {{ sectionContent.title || ('player.sidebar.section-content.context-' +
                                    sectionContent?.context | translate) }}
                                </span>

                            </a>

                            <!-- Exercise content (collapsible menu with sub-questions) -->
                            <div *ngIf="sectionContent.context === 'exercise'" class="space-y-0.5">

                                <!-- Exercise header: acts as a collapsible menu toggle -->
                                <div class="sub-link w-full flex items-center gap-3 px-2.5 py-2.5 rounded-xl text-left transition-colors no-underline cursor-pointer hover:bg-[#F6F7F9]"
                                    (click)="toggleExercise(sectionContent?.exercise?.id); $event.stopPropagation()">

                                    <!-- Exercise icon -->
                                    <span class="w-4 h-4 flex-shrink-0 flex items-center justify-center text-[#6B7280]">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                                            <path d="M9 11l3 3l8 -8"></path>
                                            <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9">
                                            </path>
                                        </svg>
                                    </span>

                                    <span class="flex-1 text-sm line-clamp-2 min-w-0 text-gray-700">
                                        {{ sectionContent.exercise.title ? (sectionContent.exercise.title | truncate) :
                                        ('player.sidebar.section-content.context-'+sectionContent?.context | translate)
                                        }}
                                    </span>

                                    <div class="context__item" *ngIf="!sectionContent?.isScorable">
                                        <div class="reset cursor-pointer"
                                            (click)="openModalReset(sectionContent?.id, modalReset); $event.stopPropagation();">
                                            <i class="icon icon-refresh-outline"></i>
                                        </div>
                                    </div>

                                    <!-- Chevron: rotates when open -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="w-4 h-4 text-gray-600 transition-transform duration-200 flex-shrink-0"
                                        [class.rotate-180]="isExerciseOpen(sectionContent?.exercise?.id)">
                                        <path d="m6 9 6 6 6-6"></path>
                                    </svg>
                                </div>

                                <!-- ===== PREGUNTAS ===== -->
                                <!-- Questions: revealed when the exercise menu is open. Scroll propio (no depende
                                     del scroll de la página ni del resto del sidebar) cuando hay muchas preguntas. -->
                                <div *ngIf="isExerciseOpen(sectionContent?.exercise?.id)"
                                    class="space-y-0.5 ml-4 pl-3 border-l-2 border-[#E8EAEF] sidebar__questions-scroll"
                                    style="max-height: 26rem; overflow-y: auto;">
                                    <a *ngFor="let question of sectionContent.exercise?.questions; let qIndex=index"
                                        [routerLink]="['section', section?.id, 'exercise', sectionContent?.exercise?.id, 'question', question?.id]"
                                        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}"
                                        queryParamsHandling="merge" routerLinkActive #qrla="routerLinkActive"
                                        class="sub-link w-full flex items-center gap-3 px-2.5 py-2.5 rounded-xl text-left transition-colors no-underline cursor-pointer hover:bg-[#F6F7F9]"
                                        [class]="getClasses(question?.id)"
                                        [attr.style]="qrla.isActive ? 'background: color-mix(in hsl, var(--secondary-100) 75%, var(--secondary-200) 25%) !important' : ''">

                                        <!-- Question state icon -->
                                        <span class="flex-shrink-0 flex items-center justify-center"
                                            [ngClass]="{'w-4 h-4': getQuestionState(question?.id)}"
                                            [style]="!getQuestionState(question?.id) ? 'border-radius: 50%; height: 18px; width: 18px; display: flex; justify-content: center; align-items: center; background-color: #f3f4f6; z-index: 5;' : ''">
                                            <!-- Correct -->
                                            <svg *ngIf="getQuestionState(question?.id) === 'success'"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-4 h-4"
                                                fill="none" stroke="#22c55e" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round">
                                                <circle cx="12" cy="12" r="10" />
                                                <path d="m8 12 3 3 5-5" />
                                            </svg>
                                            <!-- Wrong -->
                                            <svg *ngIf="getQuestionState(question?.id) === 'fail'"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-4 h-4"
                                                fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round">
                                                <circle cx="12" cy="12" r="10" />
                                                <path d="m15 9-6 6M9 9l6 6" />
                                            </svg>
                                            <!-- Pending (open-write awaiting correction) -->
                                            <svg *ngIf="getQuestionState(question?.id) === 'pending'"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-4 h-4"
                                                fill="none" stroke="#f59e0b" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round">
                                                <circle cx="12" cy="12" r="10" />
                                                <path d="M12 7v5l3 3" />
                                            </svg>
                                            <!-- Not answered yet -->
                                            <i *ngIf="!getQuestionState(question?.id)"
                                                class="icon-question fa fa-question"
                                                style="font-size: 12px; color: #6b7280;"></i>
                                        </span>

                                        <span class="flex-1 text-sm line-clamp-2 min-w-0 text-gray-700"
                                            [style.color]="qrla.isActive ? 'var(--secondary-color)' : null"
                                            *ngIf="!question?.title">
                                            {{ 'player.sidebar.section-content.exercise.question-' + question.type |
                                            translate }}
                                        </span>

                                        <span class="flex-1 text-sm line-clamp-2 min-w-0 text-gray-700"
                                            [style.color]="qrla.isActive ? 'var(--secondary-color)' : null"
                                            *ngIf="question?.title" [innerHTML]="question?.title | clean">
                                        </span>
                                    </a>
                                </div>
                            </div>

                        </ng-container>
                    </div>
                </div>

                <!-- Survey -->
                <div *ngIf="course?.hasSurvey" class="sidebar__survey py-1.5">
                    <a class="flex items-center gap-3 px-3 py-3 rounded-xl no-underline transition-colors hover:bg-[#F6F7F9]"
                        [routerLink]="['/course', course?.id, 'survey']" [routerLinkActive]="'active'"
                        [routerLinkActiveOptions]="{exact: true}"
                        [ngClass]="{'disabled-survey opacity-50 pointer-events-none': courseSubscriptionSession?.progress < 100}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-5 h-5 flex-shrink-0"
                            [style.color]="courseSubscriptionSession?.progress >= 100 ? 'var(--secondary-color)' : '#5F6877'">
                            <path d="M9 11l3 3l8 -8"></path>
                            <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9"></path>
                        </svg>
                        <span class="flex-1 text-sm font-semibold text-[#22304C]">{{ 'course.survey' | translate
                            }}</span>
                    </a>
                </div>
            </div>

            <!-- Salir del curso: separado con borde superior gris; hover gris claro. -->
            <div class="sidebar__footer border-t border-[#E8EAEF]">
                <button type="button" (click)="back()"
                    class="sidebar__leave-btn w-full flex items-center justify-start text-left gap-3 px-6 py-4 text-sm font-medium text-[#5F6877] hover:bg-[#F6F7F9] transition-colors">
                    <!-- Expandido: flecha izquierda -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="sidebar__leave-icon-full lucide lucide-arrow-left w-4 h-4 shrink-0">
                        <path d="m12 19-7-7 7-7"></path>
                        <path d="M19 12H5"></path>
                    </svg>
                    <!-- Colapsado: icono de salir (puerta) -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="sidebar__leave-icon-mini lucide lucide-log-out w-4 h-4 shrink-0">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                        <polyline points="16 17 21 12 16 7"></polyline>
                        <line x1="21" x2="9" y1="12" y2="12"></line>
                    </svg>
                    <span class="sidebar__leave-text">{{ 'words.leave-course' | translate }}</span>
                </button>
            </div>
        </div>
    </aside>
</div>

<ng-template #modalReset let-modal>
    <div class="modal-header">
        <span></span>
        <button type="button" class="close" aria-label="Close" (click)="modal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="m-modal-content">
            {{ 'player.modal.reset-quiz' | translate }}
        </div>
        <div class="m-modal-actions">
            <div>
                <button class="btn btn_color_grey" (click)="modal.close()">
                    {{ 'words.cancel' | translate }}
                </button>
            </div>

            <div class="">
                <button class="btn" (click)="resetQuiz()">
                    <div class="lds-ring" *ngIf="loading">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>

                    <span>{{ 'player.common.validate' | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</ng-template>